<template>
  <d2-container>
    <div class="scroll-container">
      <div class="frame frame1">
        <!------第一屏banner 内容页--------->
        <!-- <page-banner style="width: 100%;"></page-banner> -->
        <page-banner style="width: 100%;"></page-banner>
      </div>
      <div class="frame frame2">

        <!--------第二屏---------->
        <div class="FrameHome2">
          <div class="FrameContwidth">
            <h3 class="FrameHomeTitle">丰富的算力云服务</h3>
            <div class="FrameHome2Cont">
              <!-- <img src="/image/portalimg/frameHome2cont.png"> -->
              <img src="/image/portalimg/frameHome2cont.png"  alt="" style="width: 1592px; height: 702px" />
            </div>
          </div>
        </div>

      </div>
      <div class="frame frame3">

        <!--------第三屏---------->
        <div class="FrameHome3">
          <div class="FrameContwidth">
            <h3 class="FrameHomeTitle">高效AI算力，智引未来创新</h3>
            <div style="padding-top:34px;">
              <img src="/image/portalimg/frameHome3cont.png" style="width: 1578px; height: 712px" >
            </div>
          </div>
        </div>


      </div>
      <div class="frame frame4">

        <!--------第四屏---------->
        <div class="FrameHome4">
          <div class="FrameContwidth">
            <h3 class="FrameHomeTitle">面向千行百业的应用场景</h3>
            <div class="FrameHomeContDl">
              <dl>
                <dt><img src="/image/portalimg/frameHome4cont1.png"></dt>
                <dd>政务</dd>
              </dl>
              <dl>
                <dt><img src="/image/portalimg/frameHome4cont2.png"></dt>
                <dd>教育</dd>
              </dl>
              <dl>
                <dt><img src="/image/portalimg/frameHome4cont3.png"></dt>
                <dd>农业</dd>
              </dl>
              <dl>
                <dt><img src="/image/portalimg/frameHome4cont4.png"></dt>
                <dd>文旅</dd>
              </dl>
              <dl>
                <dt><img src="/image/portalimg/frameHome4cont5.png"></dt>
                <dd>自动驾驶</dd>
              </dl>
              <dl>
                <dt><img src="/image/portalimg/frameHome4cont6.png"></dt>
                <dd>能源</dd>
              </dl>
            </div>
            <div class="frameHome4map">
              <img src="/image/portalimg/frameHome4map.png">
            </div>
          </div>
        </div>

      </div>
      <div class="frame frame5">

        <!--------底部---------->
        <base-bottom></base-bottom>

      </div>

    </div>

    <div class="phoneHome">
      <h5>丰富的算力云服务</h5>
      <img src="/image/portalimgPhone/phoneHomebg1.png">
      <h5>高效AI算力，智引未来创新</h5>
      <img src="/image/portalimgPhone/phoneHomebg2.png">
      <div class="phoneHomebg3">
        <h5 class="screenTitle">面向千行百业的应用场景</h5>
        <!-- <img src="/image/portalimgPhone/phoneHomebg3.png"> -->
      </div>
      <div class="frame frame5">
        <!--------底部---------->
        <base-bottom></base-bottom>
      </div>
      
    </div>
  </d2-container>
</template>

<script>
import './style/page.css'
import pageBanner from './page-banner'
import baseBottom from '../components/base-bottom'


export default {
  name: "index-example",
  components: {
    pageBanner,
    baseBottom
  },
  data() {
    return {};
  },
  methods: {
    // handleScroll(event) {
    //   // 阻止默认滚动行为
    //   event.preventDefault();

    //   const container = this.$el.querySelector('.scroll-container');
    //   const frames = Array.from(this.$el.querySelectorAll('.frame'));

    //   if (!container || frames.length === 0) return;

    //   // 获取当前滚动位置
    //   const scrollTop = container.scrollTop;

    //   // 找到最接近的 frame
    //   let currentIndex = frames.findIndex((frame, index) => {
    //     return scrollTop >= frame.offsetTop && (index === frames.length - 1 || scrollTop < frames[index + 1].offsetTop);
    //   });

    //   // 根据滚动方向调整目标帧
    //   if (event.deltaY > 0 && currentIndex < frames.length - 1) {
    //     this.scrollToFrame(frames, currentIndex + 1, container);
    //   } else if (event.deltaY < 0 && currentIndex > 0) {
    //     this.scrollToFrame(frames, currentIndex - 1, container);
    //   }
    // },

    // scrollToFrame(frames, index, container) {
    //   const targetFrame = frames[index];
    //   if (targetFrame) {
    //     container.scrollTo({
    //       top: targetFrame.offsetTop,
    //       behavior: 'smooth',
    //     });
    //   }
    // },
  },
  mounted() {
    // const container = this.$el.querySelector('.scroll-container');

    // if (container) {
    //   // 添加鼠标滚轮事件监听器
    //   container.addEventListener('wheel', this.handleScroll, { passive: false });

    //   // 添加触摸事件支持
    //   let startY = 0;
    //   let startTime = 0;

    //   container.addEventListener('touchstart', (event) => {
    //     startY = event.touches[0].pageY;
    //     startTime = new Date().getTime();
    //   });

    //   container.addEventListener('touchmove', (event) => {
    //     event.preventDefault(); // 阻止默认滚动行为

    //     const currentY = event.touches[0].pageY;
    //     const deltaY = startY - currentY;

    //     if (Math.abs(deltaY) > 50) {
    //       const currentTime = new Date().getTime();
    //       const duration = currentTime - startTime;

    //       if (duration < 300) {
    //         // 快速滑动时触发滚动
    //         if (deltaY > 0) {
    //           this.handleScroll({ deltaY: 100 }); // 向下滚动
    //         } else {
    //           this.handleScroll({ deltaY: -100 }); // 向上滚动
    //         }

    //         startY = currentY;
    //         startTime = currentTime;
    //       }
    //     }
    //   }, { passive: false });
    // }
  },
  beforeDestroy() {
    // const container = this.$el.querySelector('.scroll-container');
    // if (container) {
    //   container.removeEventListener('wheel', this.handleScroll);
    //   container.removeEventListener('touchstart', () => {});
    //   container.removeEventListener('touchmove', () => {});
    // }
  }
}
</script>

<style scoped>
@media (min-width: 769px) {

.phoneHome{
  display: none;
}
.scroll-container {
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
  height: 100vh;
  touch-action: none;
}

.frame {
  /* scroll-snap-align: start; */
  /*height: 100vh;
   display: flex;
  justify-content: center;
  align-items: center; */
}
.frame1{
  margin-top: 60px;
  height: 500px;
}

.FrameHome1, .FrameHome2, .FrameHome3, .FrameHome4 {
  width: 100%;
  /* height: 100%; */
}
.FrameHome1{
  height: 500px;
}
.frame5 {
  height: 278px;
}

.ltjqjsl {
  z-index: 10;
  position: relative;
  width: 100%;
  height: 278px;
  text-align: center;
  background: #EDEFF7;
  background: url(/image/portalimg/bgbottom.png);
  background-size: 100% 100%;
}

.ltjqjsl .contxtmeg h3 {
  font-size: 30px;
  color: #191C3D;
  letter-spacing: 10px;
  text-align: center;
  line-height: 58px;
  font-weight: 600;
  padding: 40px 0 0;
}

.ltjqjsl .contxtmeg h4 {
  font-size: 24px;
  color: #191C3D;
  letter-spacing: 10px;
  text-align: center;
  line-height: 58px;
  font-weight: 400;
}

.ltjqjsl .contxtmeg span {
  display: inline-block;
  text-align: center;
  font-size: 12px;
  color: #FFFFFF;
  letter-spacing: 2.5px;
  text-align: center;
  font-weight: 400;
  background: #4173FF;
  padding: 5px 20px;
  margin-top: 20px;
  border-radius: 20px;
}

.ltjqjsl .contxtmeg p {
  font-size: 14px;
  color: #333333;
  text-align: center;
  font-weight: 400;
  margin-top: 10px;
}

}

@media (max-width: 768px) {
  .scroll-container{
    display: none;
  }
  .phoneHome{
    width: 100%;
    background: #f2f7ff;
    margin-top: 50px;
  }
  .phoneHome h5{
    text-align: center;
    font-size: 16px;
    padding: 20px 0;
  }
  .phoneHomebg3{
    background: url(/image/portalimgPhone/phoneHomebg3.png) no-repeat center;
    position: relative;
    width: 100%;
    background-size: 100%;
    height: 724px;
    margin-top: 30px;
  }
  .phoneHome h5.screenTitle{
    width: 100%;
    margin-top: 10px;
    position: absolute;
  }
  .phoneHome img{
    width: 100%;
    height: 100%;
  }
  
}
</style>
